/**
 * @param {*} filePath
 * @param {*} fileUrl
 * @returns {toothNumberDO | null}
 */

import { getRawDataFromToothNumberRaw } from "../convert/rawConver";

export const getToothNumberDOFromFilePath = async (filePath, fileData) => {
  const regex = /.*__(LOWER|UPPER)__TOOTH_NUMBERS.raw$/i;
  const match = filePath.match(regex);
  if (match) {
    const toothGumType = match[1];
    const toothNumberList = await getRawDataFromToothNumberRaw(fileData)
    return {
      toothGumType,
      toothNumberList
    }
  }
  return null;
};
